<template>
  <div>
    <h1>Welcome to Your Package!</h1>
    <p>This is the main component for your package's routes.</p>
    <SipAgent />
  </div>
</template>

<script setup>
// This component is intentionally simple.
// You can add any shared logic for your package's routes here.


import SipAgent from '../components/SipAgent.vue'
</script>
